import { useFormContext, Controller } from "react-hook-form";

import { IconButton } from "ui/icon-button";
import { FieldLabel } from "ui/forms";
import ThemePaddingSimple from "containers/admin/clients/client/theme-page/preview/components/theme-padding/theme-padding-simple";
import ThemePaddingCustom from "containers/admin/clients/client/theme-page/preview/components/theme-padding/theme-padding-custom";

import { useThemePreviewContext } from "containers/admin/clients/client/theme-page/contexts/theme-preview-context";
import { useThemePadding } from "containers/admin/clients/client/theme-page/preview/components/theme-padding/use-theme-padding";

import Icons from "assets";

interface ThemePaddingProps {
  formFieldPrefix: string; // ex. "layout.contentArea" or "button.padding"
  label: string;
  customClassLabel?: string;
}

const ThemePadding = ({ formFieldPrefix, label, customClassLabel }: ThemePaddingProps) => {
  const { isEditMode } = useThemePreviewContext();
  const { control, watch } = useFormContext();

  const isCustomMode = watch(`${formFieldPrefix}.isCustom`);

  const { handleCustomModeToggle } = useThemePadding(formFieldPrefix);

  return (
    <div>
      <FieldLabel name={formFieldPrefix}>
        <span className={customClassLabel}>{label}</span>
      </FieldLabel>
      <div className="flex flex-row gap-2 items-start mt-1.5">
        {!isCustomMode ? (
          <ThemePaddingSimple formFieldPrefix={formFieldPrefix} />
        ) : (
          <ThemePaddingCustom formFieldPrefix={formFieldPrefix} />
        )}

        <Controller
          name={`${formFieldPrefix}.isCustom`}
          control={control}
          render={({ field }) => (
            <IconButton
              aria-label={isCustomMode ? "Switch to simple padding" : "Switch to custom padding"}
              variant="outlined"
              size="large"
              disabled={!isEditMode}
              onClick={() => handleCustomModeToggle(isCustomMode, field.onChange)}>
              <Icons.Padding />
            </IconButton>
          )}
        />
      </div>
    </div>
  );
};

export default ThemePadding;
